module.exports = __webpack_public_path__ + "static/media/slide-4.2472c5a3.png";